import { Upload, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

interface TaskIconUploaderProps {
  previewUrl: string | null;
  fileName: string | null;
  uploadedIconFile: File | null;
  onUpload: (file: File) => void;
  onRemove: () => void;
}

const truncateName = (str: string, maxLength = 10) =>
  str.length > maxLength ? `${str.slice(0, maxLength)}...` : str;

export const TaskIconUploader: React.FC<TaskIconUploaderProps> = ({
  previewUrl,
  fileName,
  uploadedIconFile,
  onUpload,
  onRemove,
}) => {
  const { t } = useTranslation();

  return (
    <Upload
      accept="image/*"
      showUploadList={{
        showPreviewIcon: false,
        showRemoveIcon: true,
      }}
      fileList={
        uploadedIconFile || previewUrl
          ? [
              {
                uid: "-1",
                name: truncateName(fileName || "uploaded_file.png"),
                status: "done",
                thumbUrl: previewUrl || "",
              },
            ]
          : []
      }
      beforeUpload={(file) => {
        const reader = new FileReader();
        reader.onload = () => {
          onUpload(file);
        };
        reader.readAsDataURL(file);
        return false;
      }}
      onRemove={onRemove}
    >
      {previewUrl ? (
        <img
          src={previewUrl}
          alt={t("taskHub.modal.preview") || ""}
          className="w-8 h-8 rounded-full object-cover border"
        />
      ) : (
        <Button className="w-8 h-8 rounded-full p-0">
          <PlusOutlined className="p-0 mb-1" />
        </Button>
      )}
    </Upload>
  );
};
